import * as changeCase from 'change-case';
export const transformGqlActionName = (name, type) => {
    const postfix = type ? changeCase.capitalCase(type) : '';
    return changeCase.capitalCase(name).replace(/ /gi, '') + postfix;
};
